module.exports = __webpack_public_path__ + "static/media/demo_1.631ee721.mp4";